/* eslint-disable no-restricted-imports */
import { Img } from '@/components/blocks/MaterialImage';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { ProductRibbons } from '@/components/blocks/Ribbons';
import {
	productPLPPriceSX,
	productPLPSubtitleSX,
	productPLPTitleSX,
} from '@/components/content/CatalogEntryList/styles/typography';
import { useProductEvents } from '@/data/Content/_ProductEvents';
import { calculateProductPriceIncrease } from '@/data/Content/BasicCheckOut/utils/calculateProductPriceIncrease';
import { ProductType } from '@/data/types/Product';
import { combineSX } from '@/utils/combineSX';
import { formatPrice } from '@/utils/formatPrice';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import Link from 'next/link';
import { FC, MouseEventHandler } from 'react';

export const ProductCardPLP: FC<{
	product: ProductType;
	inFavorites?: boolean;
	onToggleFavorite?: MouseEventHandler<HTMLButtonElement>;
	clickAction?: () => void;
	isFavorite?: boolean;
}> = ({ product, inFavorites, onToggleFavorite, clickAction, isFavorite }) => {
	const { onClick } = useProductEvents({ product });
	const ribbons = mergeRibbonsForProduct(product.ribbons);
	const priceIncrease = calculateProductPriceIncrease(product.productPrice.list ?? 0);

	return (
		<Grid item xs={6} md={4} id={product.partNumber}>
			<Box border="1px solid #DADCE0" onClick={onClick(clickAction)}>
				<Link href={`${product?.seo?.href}`}>
					<RenderProductImg
						fullImageRaw={product.thumbnail}
						render={(src) => (
							<Grid sx={{ position: 'relative' }}>
								<ProductRibbons ribbons={ribbons} />
								{onToggleFavorite ? (
									<IconButton
										sx={{
											position: 'absolute',
											top: '8px',
											right: '8px',
											zIndex: 1,
											backgroundColor: 'white',
											boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
										}}
										onClick={onToggleFavorite}
									>
										{inFavorites ? (
											<FavoriteIcon color="primary" />
										) : (
											<FavoriteBorderIcon color="primary" />
										)}
									</IconButton>
								) : null}
								<Img
									src={src}
									sx={{
										height: { xs: '200px', sm: isFavorite ? '200px' : '350px' },
										width: { xs: '100%', md: isFavorite ? '200px' : '100%' },
										objectFit: { xs: 'contain', lg: 'contain' },
										backgroundColor: '#cbcbcb',
									}}
								/>
							</Grid>
						)}
					/>
				</Link>
				<Box
					sx={{
						width: isFavorite ? '200px' : 'auto',
						height: '124px',
						p: '0px 15px 15px 15px',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-between',
					}}
				>
					<Box>
						<Typography sx={productPLPTitleSX}>{product.name}</Typography>
						<Typography sx={combineSX([productPLPSubtitleSX, { fontWeight: '300' }])}>
							{product.manufacturer}
						</Typography>
					</Box>
					<Typography sx={productPLPPriceSX}>
						{formatPrice('es-MX', 'MXN', priceIncrease)}
					</Typography>
				</Box>
			</Box>
		</Grid>
	);
};
